import gql from 'graphql-tag'

export const fieldEntityListStatus = gql`
  query FieldEntityListStatus($entityId: Int!, $token: String, $userId: Int) {
    fieldEntityListStatus(entityId: $entityId, token: $token, userId: $userId) {
      fields
      dataFields
    }
  }
`
